// Section 18: Burial policy. Field burial until a cemetery exists.
// Default: config.policies.defaults.burial.
import type { Config } from '../../config';
import { hasBuilding } from '../../core/queries';
import { noChangeCost } from '../../core/content-helpers';
import { definePolicy, noModifiers } from '../../core/registry';

export function burial(config: Config) {
  return definePolicy({
    id: 'burial',
    label: 'Burial',
    section: 'S18',
    group: 'society',
    options: ['cemetery', 'field'],
    default: config.policies.defaults.burial,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    // M6: grief and the happiness a death costs under each burial (Sections 9 and 15).
    affects(_ctx, option) {
      const l = config.lifecycle;
      const cemetery = option === 'cemetery';
      return [
        {
          key: `policy.burial.${option}`,
          params: {
            seasons: cemetery
              ? Math.ceil(l.griefSeasons * config.buildings.cemetery.griefMul)
              : l.griefSeasons,
            happiness: cemetery ? l.deathHappinessCemetery : l.deathHappinessNoCemetery,
          },
        },
      ];
    },
    validate(ctx, option) {
      if (option === 'field' || hasBuilding(ctx.state, 'cemetery')) return null;
      return {
        path: 'policies.burial',
        code: 'policy_locked',
        message: 'Cemetery burial needs a cemetery.',
      };
    },
  });
}
